/**
 * Compact SVG sparkline for the Parts Pipeline "Installed Revenue · 30d" card.
 * No chart library — just raw SVG bars so it prints crisply on the iPad.
 * Data: [{ date: "YYYY-MM-DD", installed_value: number }]
 */
export default function RevenueSparkline({ data = [], color = "#059669" }) {
  if (!data || data.length === 0) {
    return <div className="text-xs text-muted-foreground">No trend data yet.</div>;
  }
  const width = 260;
  const height = 56;
  const gap = 2;
  const barCount = data.length;
  const barWidth = Math.max(1, (width - gap * (barCount - 1)) / barCount);
  const max = Math.max(...data.map((d) => d.installed_value || 0), 1);

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      width="100%"
      height={height}
      preserveAspectRatio="none"
      data-testid="revenue-sparkline"
    >
      {data.map((d, i) => {
        const h = ((d.installed_value || 0) / max) * (height - 4);
        const x = i * (barWidth + gap);
        const y = height - h;
        return (
          <rect
            key={d.date}
            x={x}
            y={y}
            width={barWidth}
            height={h}
            rx={0.6}
            fill={color}
            opacity={0.35 + 0.65 * (i / (barCount - 1 || 1))}
          />
        );
      })}
    </svg>
  );
}
